import { useQuery } from '@tanstack/react-query';
import { usersApi } from '../services/users.service';

export interface Invite {
    id: string;
    email: string;
    status?: string;
    redeemed?: boolean;
    redeemedAt?: string;
    createdAt?: string;
    deletedAt?: string;
}

export const useGetOrganizationInvites = (organizationId: string) => {
    return useQuery<Invite[]>({
        queryKey: ['organizationInvites', organizationId],
        queryFn: async () => {
            if (!organizationId) {
                throw new Error('Organization ID is required to fetch invites');
            }
            const response = await usersApi.getOrganizationInvites(organizationId);
            const invites: Invite[] = Array.isArray(response.data) ? response.data : [response.data];
            return invites.filter((invite) => !invite.deletedAt);
        },
        enabled: !!organizationId,
    });
};
